module.exports = __webpack_public_path__ + "img/clouds-moon.d71d8ae3.svg";